export const isCategory = (name) => /^attributes\.categoriesL\d+$/.test(name);
